import { render, staticRenderFns } from "./ListVault.vue?vue&type=template&id=2225e232&"
import script from "./ListVault.vue?vue&type=script&lang=js&"
export * from "./ListVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports